import React, {useEffect, useState, useRef} from "react";
import { Stack, Box, TextField, Button } from "@mui/material";
import { ListTitle } from "../Common/CommonStyle";
import {
    BoxTitle,
    CardBoxViewer,
    ChatBox,
    ListBox,
    SpeechBubble,
    Root,
} from "./RagTestDailogStyle";
import { inject, observer } from "mobx-react";

function RagTestDialog(props) {
    const {dashboardStore, isTestEnabled, sendMessage, setSendMessage} = props;
    const chatBoxRef = useRef(null);

    useEffect(() => {
        dashboardStore.setTestRagBookPrompt('');
        dashboardStore.setTestRagBookDialogList([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const scrollToBottom = () => {
        setTimeout(() => {
            if (chatBoxRef.current) {
                chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
            }
        }, 100);
    };

    useEffect(() => {
        // ChatBox의 내용 변경을 감지하는 observer 설정
        const chatBoxElement = chatBoxRef.current;
        if (chatBoxElement) {
            const observer = new MutationObserver(scrollToBottom);
            observer.observe(chatBoxElement, {
                childList: true,
                subtree: true
            });

            return () => observer.disconnect();
        }
    }, []);

    // 대화 목록이 변경될 때도 스크롤
    useEffect(() => {
        scrollToBottom();
    }, [dashboardStore.testRagBookDialogList]);

    const handleSendMessage = () => {
        if (sendMessage.trim()) {
            const chatList = dashboardStore.testRagBookDialogList;
            chatList.push({
                role: 'user',
                content: sendMessage.trim()
            });
            setSendMessage('');
            dashboardStore.getTestRagBook();
            scrollToBottom(); // 메시지 전송 시에도 스크롤
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    return (
        <Root sx={{
            paddingTop: 0,
            height: '100%',
        }}>
            <Box sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}>
                <CardBoxViewer sx={{
                    flex: '0 0 200px',
                }}>
                    <BoxTitle>
                        <ListTitle variant="subtitle2">
                            프롬프트 입력
                        </ListTitle>
                    </BoxTitle>
                    <ListBox sx={{
                        height: 'calc(100% - 40px)',
                        width: '100%'
                    }}>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            placeholder="프롬프트 내용을 입력해주세요"
                            value={dashboardStore.testRagBookPrompt}
                            onChange={(e) => dashboardStore.setTestRagBookPrompt(e.target.value)}
                            sx={{
                                backgroundColor: '#fff',
                                height: '100%',
                                width: '100%',
                                '& .MuiOutlinedInput-root': {
                                    height: '100%',
                                    width: '100%',
                                    '& fieldset': {
                                        borderColor: '#e0e0e0',
                                    },
                                    '& textarea': {
                                        height: '100% !important',
                                    }
                                },
                            }}
                        />
                    </ListBox>
                </CardBoxViewer>

                <ChatBox 
                    ref={chatBoxRef}
                    sx={{ 
                        flex: '1 1 auto',
                        width: '100%',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        marginTop: '16px',
                        marginBottom: '16px'
                    }}
                >
                    {dashboardStore.testRagBookDialogList.map((dialog, index) => {
                        if (dialog.role === 'user') {
                            return (
                                <SpeechBubble key={index} className='answer'>
                                    <Stack maxWidth='80%'>
                                        <Box className="bubble">{dialog.content}</Box>
                                    </Stack>
                                </SpeechBubble>
                            )
                        } else {
                            return (
                                <SpeechBubble key={index} className='question'>
                                    <Box className="bubble">{dialog.content}</Box>
                                </SpeechBubble>
                            )
                        }
                    })}
                </ChatBox>

                {isTestEnabled &&
                    <CardBoxViewer sx={{
                        flex: '0 0 60px',
                        padding: '8px',
                    }}>
                        <Box sx={{
                            display: 'flex',
                            gap: 1,
                            height: '100%',
                        }}>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder="메시지를 입력하세요"
                                value={sendMessage}
                                onChange={(e) => setSendMessage(e.target.value)}
                                onKeyPress={handleKeyPress}
                                sx={{
                                    backgroundColor: '#fff',
                                    '& .MuiOutlinedInput-root': {
                                        height: '100%',
                                        '& fieldset': {
                                            borderColor: '#e0e0e0',
                                        },
                                    },
                                }}
                            />
                            <Button
                                variant="contained"
                                disabled={dashboardStore.testRagBookPrompt.trim() === '' || sendMessage.trim() === ''} style={dashboardStore.testRagBookPrompt.trim() === '' || sendMessage.trim() === '' ? {backgroundColor: '#D3D3D3', color: '#FFF'} : {backgroundColor: '#F9CB28', color: '#49454F'}}
                                onClick={handleSendMessage}
                                sx={{
                                    minWidth: '80px',
                                    height: '100%',
                                }}
                            >
                                전송
                            </Button>
                        </Box>
                    </CardBoxViewer>
                }
            </Box>
        </Root>
    );
}

export default inject('dashboardStore')(observer(RagTestDialog));